export default __webpack_public_path__ + "static/media/Zz.7be08bff.wav";